// extracted by mini-css-extract-plugin
export var story__description = "storyThirdSection-module--story__description--01mGB";
export var story__imageOne = "storyThirdSection-module--story__imageOne--ujI7z";
export var story__imageTwo = "storyThirdSection-module--story__imageTwo--q0mEQ";